import { createDemoSourcePort } from '#shared';

import type { ActiveCasesResponse } from './schemas';

export type DemoActiveCasesSource = (nowMs: number) => ActiveCasesResponse;

const port = createDemoSourcePort<DemoActiveCasesSource>();

export const registerDemoActiveCasesSource = port.register;
export const loadDemoActiveCasesSource = port.load;
